import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'mrh_detail.title',
  },
  preventionGuideTitle: {
    id: 'mrh_detail.prevention_guide_title',
  },
  preventionGuideSubTitle: {
    id: 'mrh_detail.prevention_guide_subtitle',
  },
  waterDamage: {
    id: 'mrh_detail.waterDamage',
  },
  fire: {
    id: 'mrh_detail.fire',
  },
  vol: {
    id: 'mrh_detail.vol',
  },
  CarbonMonoxidePoisoning: {
    id: 'mrh_detail.Carbon_monoxide_poisoning',
  },
  assureDoit: {
    id: 'mrh_detail.assure_doit',
  },
  CarbonMonoxidePoisingParagraph: {
    id: 'mrh_detail.Carbon_monoxide_poisoning_paragraph',
  },
  waterDamageParagraph: {
    id: 'mrh_detail.water_damage_paragraph',
  },
  waterDamageList: {
    id: 'mrh_detail.water_damage_list',
  },
  fireParagraph: {
    id: 'mrh_detail.fire_paragraph',
  },
  fireList: {
    id: 'mrh_detail.fire_list',
  },
  volParagraph: {
    id: 'mrh_detail.vol_paragraph',
  },
  volList: {
    id: 'mrh_detail.vol_list',
  },
  title_suivi_sinistre_mrh: {
    id: 'suivi_sinistre_mrh.title',
  },
  content_suivi_sinistre_mrh: {
    id: 'suivi_sinistre_mrh.content',
  },
  contact_service_mrh: {
    id: 'suivi_sinistre_mrh.contact_service',
  },
  agent_service_mrh: {
    id: 'suivi_sinistre_mrh.contact_agent',
  },
  email_contact_mrh: {
    id: 'suivi_sinistre_mrh.contact_email',
  },
  close: {
    id: 'modal.close',
  },
  declarer_Sinistre_title: {
    id: 'dashboard_auto.declarer_sinistre_title',
  },
  declarer_Sinistre_description: {
    id: 'dashboard_auto.declarer_sinistre_description',
  },
  que_faire_en_cas_sinistre: {
    id: 'dashboard_mrh.que_faire_en_cas_sinistre',
  },
});
